import {NgModule} from '@angular/core';
import {RcSwitcherComponent} from './components/rc-switcher/rc-switcher.component';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RcTextareaComponent} from './components/rc-textarea/rc-textarea.component';
import {RcTextareaAutoresizeDirective} from './directives/rc-textarea-autoresize/rc-textarea-autoresize.directive';
import {RcPopupWrapperComponent} from './components/rc-popup-wrapper/rc-popup-wrapper.component';
import {RcAutofocusDirective} from './directives/rc-autofocus/rc-autofocus.directive';
import {ModalModule} from 'ngx-bootstrap/modal';
import {PopoverModule} from 'ngx-bootstrap/popover';
import {RcPopoverComponent} from './components/rc-popover/rc-popover.component';
import {BsDatepickerModule} from 'ngx-bootstrap';
import {RcDatepickerComponent} from './components/rc-datepicker/rc-datepicker.component';
import {RcCheckboxComponent} from './components/rc-checkbox/rc-checkbox.component';
import {RcRadiosComponent} from './components/rc-radios/rc-radios.component';
import {RcRadioComponent} from './components/rc-radios/rc-radio.component';
import {RcInputComponent} from './components/rc-input/rc-input.component';
import {RcAutoCompleteComponent} from './components/rc-autocomplete/rc-autocomplete.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {RcItemsLayoutComponent} from './components/rc-items-layout/rc-items-layout.component';
import {RcItemLayoutComponent} from './components/rc-items-layout/rc-item-layout.component';
import {RcItemDrawerComponent} from './components/rc-items-layout/rc-item-drawer.component';
import {RcInviewDirective} from './directives/rc-inview/rc-inview.directive';
import {RcClickOutsideDirective} from './directives/rc-click-outside/rc-click-outside.directive';
import {RcTableComponent} from './components/rc-table/rc-table.component';
import {RcTableCellComponent} from './components/rc-table/rc-table-cell.component';
import {RcTableHeaderComponent} from './components/rc-table/rc-table-header.component';
import {RcTableRowComponent} from './components/rc-table/rc-table-row.component';
import {RcTableDrawerComponent} from './components/rc-table/rc-table-drawer.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { RcRecaptchaComponent } from './components/rc-recaptcha/rc-recaptcha.component';
import {RcTruncatePipe} from './pipes/rc-truncate/rc-truncate.pipe';
import {RcContrastColorsComponent} from './components/rc-colors-contrast-toggle/rc-contrast-colors.component';
import {RcTranslatePipe} from './pipes/rc-translate/rc-translate.pipe';
import {RcNumberPipe} from './pipes/rc-number/rc-number.pipe';
import {RcFileInputComponent} from './components/rc-file-input/rc-file-input.component';
import {RcImageFallbackDirective} from './directives/rc-image-preload/rc-image-fallback.directive';
import {RcImagePipe} from './pipes/rc-image/rc-image.pipe';
import {RcTableFooterRowComponent} from './components/rc-table/rc-table-footer-row.component';
import {RcScrollToDirective} from './directives/rc-scroll-to/rc-scroll-to.directive';
import {RcTableRowExtensionComponent} from './components/rc-table/rc-table-row-extension.component';
import {RcDateRangePickerComponent} from './components/rc-date-range-picker/rc-date-range-picker.component';

const components: any[] = [
    RcSwitcherComponent,
    RcTextareaComponent,
    RcPopupWrapperComponent,
    RcPopoverComponent,
    RcDatepickerComponent,
    RcRadiosComponent,
    RcRadioComponent,
    RcTextareaAutoresizeDirective,
    RcAutofocusDirective,
    RcCheckboxComponent,
    RcInputComponent,
    RcAutoCompleteComponent,
    RcItemsLayoutComponent,
    RcItemLayoutComponent,
    RcItemDrawerComponent,
    RcInviewDirective,
    RcClickOutsideDirective,
    RcImageFallbackDirective,
    RcTableComponent,
    RcTableRowComponent,
    RcTableFooterRowComponent,
    RcTableDrawerComponent,
    RcTableCellComponent,
    RcTableHeaderComponent,
    RcTableRowExtensionComponent,
    RcRecaptchaComponent,
    RcContrastColorsComponent,
    RcFileInputComponent,
    RcTruncatePipe,
    RcNumberPipe,
    RcTranslatePipe,
    RcImagePipe,
    RcScrollToDirective,
    RcDateRangePickerComponent
];

/**
 * Rc UI module
 * Includes a UI components and directives
 *
 * @example
 * import { RcUiModule } from '@realcommerce/rc-ui';
 *
 * @NgModule({
 *    declarations: [
 *      AppComponent
 *    ],
 *    imports: [
 *      BrowserModule,
 *      RcUiModule
 *    ],
 *    providers: [],
 *    bootstrap: [AppComponent]
 *  })
 *   export class AppModule { }
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot(),
        PopoverModule.forRoot(),
        BsDatepickerModule.forRoot(),
        NgSelectModule,
        NgxCaptchaModule
    ],
    providers: [],
    declarations: [...components],
    exports: [...components]
})
export class RcUiModule {
}
